export const BOOKING_REGISTRATION = 'registration';
export const BOOKING_FULL = 'full';
export const BOOKING_EXPIRED = 'expired';
export const BOOKING_MANAGE = 'manage';
export const BOOKING_OPEN_SOON = 'open-soon';
